import { DEFAULT_LANGUAGE, isValidLanguage, SupportedLanguage } from '../types/i18n.ts'

/**
 * Jezični prefiks rute. Hrvatski se poslužuje na korijenu bez prefiksa
 * (vidi baseRoutes u src/router/index.tsx), ostali jezici dobivaju /{lang}.
 */
export const getLangPrefix = (lang?: string): string => {
	if (!lang || !isValidLanguage(lang) || lang === DEFAULT_LANGUAGE) return ''
	return `/${lang}`
}

/**
 * Sastavlja internu rutu s jezičnim prefiksom.
 * withLang('de', '/price') -> '/de/price'
 * withLang('hr', '/price') -> '/price'
 */
export const withLang = (lang: string | undefined, path: string): string => {
	const normalized = path.startsWith('/') ? path : `/${path}`
	const prefixed = `${getLangPrefix(lang)}${normalized}`

	// Firebase trailingSlash:false; jedino korijen zadržava završnu kosu crtu.
	return prefixed.replace(/\/$/, '') || '/'
}

/**
 * i18n.language zna nositi regionalni sufiks ('de-DE') ili nepodržan kod.
 * Svodi ga na jedan od SUPPORTED_LANGUAGES.
 */
export const normalizeLanguage = (lang?: string): SupportedLanguage => {
	if (!lang) return DEFAULT_LANGUAGE
	const base = lang.split('-')[0]
	return isValidLanguage(base) ? base : DEFAULT_LANGUAGE
}
